import { OrderItem } from './entities/interface';

type GstBooking = {
  applyGst?: boolean;
  tax?: {
    gst?: number;
    totalTax?: number;
  };
} | null;

export const isGstAppliedOnBooking = (booking?: GstBooking) =>
  booking?.applyGst !== false && Number(booking?.tax?.gst || 0) > 0;

export const resolveGstRate = (
  booking: GstBooking,
  applyGstEnabled: boolean,
  activeGstRate = 0,
) => {
  if (!applyGstEnabled) {
    return 0;
  }

  const storedRate = Number(booking?.tax?.gst);
  if (!Number.isNaN(storedRate) && storedRate > 0) {
    return storedRate;
  }

  return Number(activeGstRate || 0);
};

export const calculateInvoiceTotals = (
  items: Pick<OrderItem, 'price' | 'quantity'>[],
  gstRate: number,
) => {
  const subtotal = items.reduce((total, item) => {
    return total + Number(item.price || 0) * Number(item.quantity || 0);
  }, 0);

  const gstAmount =
    gstRate > 0 ? parseFloat(((subtotal * gstRate) / 100).toFixed(2)) : 0;
  const grandTotal = parseFloat((subtotal + gstAmount).toFixed(2));

  return { subtotal, gstAmount, grandTotal };
};
